import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAFLHoFCW8DeXsF276UQ9xqxL4NztYsY2o",
  authDomain: "hoei-hp.firebaseapp.com",
  projectId: "hoei-hp",
  storageBucket: "hoei-hp.appspot.com",
  messagingSenderId: "540469761034",
  appId: "1:540469761034:web:fc8992a30cfe523d85fbf3",
  measurementId: "G-SZD77BHY1S",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);
